import React from "react";
import "./HowItWorksSection.css";
import { Phone, CreditCard, Banknote, CheckCircle } from "lucide-react";

const steps = [
  { icon: Phone, step: "01", title: "Call Us", desc: "Reach out on 9884135738 or 6385417845" },
  { icon: CreditCard, step: "02", title: "Visit & Swipe", desc: "Visit our nearest location and swipe your card" },
  { icon: Banknote, step: "03", title: "Get Cash", desc: "Receive instant cash in your bank account" },
  { icon: CheckCircle, step: "04", title: "Done!", desc: "Transaction complete in under 5 minutes" },
];

const HowItWorksSection = () => {
  return (
    <section className="how-it-works">
      {/* Decorative background circles */}
      <div className="bg-circle circle-top" />
      <div className="bg-circle circle-bottom" />

      <div className="how-container">
        <div className="how-header fade-in-up">
          <h2 className="how-title">How It Works</h2>
          <p className="how-subtitle">Simple 4-step process — done in minutes</p>
        </div>

        <div className="how-grid">
          {steps.map((s, i) => (
            <div 
              key={s.step} 
              className="how-step-card fade-in-up"
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              <div className="how-icon-wrapper">
                <s.icon className="how-icon" />
                <span className="step-number">{s.step}</span>
              </div>
              
              <h3 className="how-step-title">{s.title}</h3>
              <p className="how-step-desc">{s.desc}</p>

              {/* Connecting line for desktop */}
              {i < steps.length - 1 && <div className="step-connector" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;